import Skeleton from "../../common/Skeleton";

const InfoModalSkeleton = () => {
  return (
    <div className="p-4 sm:p-6 rounded-lg flex-1 flex flex-col h-full overflow-hidden">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 flex-1 min-h-0">
        {/* Part 1: Company Details */}
        <div className="flex flex-col min-h-0">
          <div className="flex flex-col flex-shrink-0 min-w-0 mb-4 pb-4 border-b border-gray-200 dark:border-gray-700">
            <Skeleton className="w-48 h-7 mb-2 rounded" />
            <div className="flex gap-2">
              <Skeleton className="w-20 h-4 rounded" />
              <Skeleton className="w-24 h-4 rounded" />
            </div>
          </div>

          <Skeleton className="w-48 h-6 mb-3 rounded" />

          <div className="grid grid-cols-2 md:grid-cols-2 gap-4 mb-4 mt-2">
            <div>
              <Skeleton className="w-16 h-3 mb-1 rounded" />
              <Skeleton className="w-28 h-5 rounded" />
            </div>
            <div>
              <Skeleton className="w-16 h-3 mb-1 rounded" />
              <Skeleton className="w-28 h-5 rounded" />
            </div>
          </div>

          <div className="mb-2 mt-4 flex flex-col flex-1 min-h-0">
            <Skeleton className="w-20 h-3 rounded mb-2 flex-shrink-0" />
            <div className="overflow-y-auto pr-2 h-full space-y-2">
              <Skeleton className="w-full h-4 rounded" />
              <Skeleton className="w-full h-4 rounded" />
              <Skeleton className="w-full h-4 rounded" />
              <Skeleton className="w-3/4 h-4 rounded" />
            </div>
          </div>
        </div>

        {/* Part 2: Risk, Reward */}
        <div className="border-t md:border-t-0 md:border-l border-gray-200 dark:border-gray-700 pt-6 md:pt-0 md:pl-6 flex flex-col min-h-0">
          <div className="flex-1 overflow-y-auto pr-2 min-h-0 mb-2">
            {/* Reward Box */}
            <div className="bg-white/90 dark:bg-[#1E1E2D]/90 rounded-lg shadow-lg border border-[#e0e0e0] dark:border-[#333] p-4 mb-4">
              <div className="flex items-center gap-2 mb-4">
                <Skeleton className="w-6 h-6 rounded-full" />
                <Skeleton className="w-60 h-4 rounded" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="p-2 rounded-lg bg-gradient-to-br from-[#f4f6fb] to-[#e9ebf3] dark:from-[#2a2d3e] dark:to-[#1f2230] shadow-sm h-16 flex flex-col justify-center gap-2"
                  >
                    <Skeleton className="w-20 h-3 rounded" />
                    <Skeleton className="w-12 h-4 rounded" />
                  </div>
                ))}
              </div>
            </div>

            {/* Risk Box */}
            <div className="bg-white/90 dark:bg-[#1E1E2D]/90 rounded-lg shadow-lg border border-[#e0e0e0] dark:border-[#333] p-4 mb-4">
              <div className="flex items-center gap-2 mb-4">
                <Skeleton className="w-6 h-6 rounded-full" />
                <Skeleton className="w-60 h-4 rounded" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
                {[...Array(3)].map((_, i) => (
                  <div
                    key={i}
                    className="p-2 rounded-lg bg-gradient-to-br from-[#f4f6fb] to-[#e9ebf3] dark:from-[#2a2d3e] dark:to-[#1f2230] shadow-sm h-16 flex flex-col justify-center gap-2"
                  >
                    <Skeleton className="w-20 h-3 rounded" />
                    <Skeleton className="w-12 h-4 rounded" />
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-indigo-50/50 dark:bg-indigo-900/20 rounded-lg border border-indigo-100 dark:border-indigo-800/30 p-3 mt-1 h-32"></div>
          </div>

          <div className="p-3 bg-amber-50 dark:bg-amber-900/20 rounded-md flex-shrink-0 mt-2 mr-2">
            <Skeleton className="w-20 h-3 rounded mb-2" />
            <Skeleton className="w-full h-3 rounded mb-2" />
            <Skeleton className="w-3/4 h-3 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfoModalSkeleton;
